import { render } from "./ProductChoosableCollection.vue?vue&type=template&id=3653794b&scoped=true"
import script from "./ProductChoosableCollection.vue?vue&type=script&lang=js"
export * from "./ProductChoosableCollection.vue?vue&type=script&lang=js"

import "./ProductChoosableCollection.vue?vue&type=style&index=0&id=3653794b&lang=scss&scoped=true"

import exportComponent from "G:\\ElectronicPointOfSales\\Mang.EposApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3653794b"]])

export default __exports__